export const Steps = { // 0: Upload Status, 1: Update Fields, 2: Upload Spec File, 3: Spec Data Preview
  FILE_STATUS_TABLE: "Upload Status",
  UPDATE_FIELDS: "Fields",
  UPLOAD_SPEC_FILE: "Upload Spec",
  SPEC_DATA_PREVIEW: "Spec Data Preview",
};

export const StepStatus = { // 0: waiting, 1: processing, 2: finsihed, 3: error
  WAITING: 0,
  PROCESSING: 1,
  FINISHED: 2,
  ERROR: 3,
};

export const Specstype = {
  Product: "product",
  Environment: "environment",
};
